/** Preset prompts for Ask Eve container debug quick actions (IT). */

export const ASK_EVE_RISK_PROMPT =
    "Quanto è a rischio questa spedizione? Usa assess_container_risk con il container del contesto (container_id) e riporta score, livello di rischio e raccomandazioni.";

export const ASK_EVE_FORENSICS_PRESETS: { id: string; label: string; question: string }[] = [
    {
        id: "eta",
        label: "Verifica ETA",
        question:
            "Controlla se l'ETA di questo container è corretto. Analizza tutte le fonti (email, documenti, tracking carrier) e dimmi se ci sono discrepanze o aggiornamenti recenti che non sono stati recepiti.",
    },
    {
        id: "pod",
        label: "Verifica porto di scarico",
        question:
            "Controlla se il porto di scarico di questo container è corretto. Verifica coerenza tra documenti, email del carrier e tracking JSONCargo.",
    },
    {
        id: "carrier",
        label: "Verifica carrier e vessel",
        question:
            "Controlla se carrier, vessel e voyage di questo container sono coerenti tra le diverse fonti (documenti, email, tracking).",
    },
    {
        id: "weight",
        label: "Verifica peso e cargo",
        question:
            "Controlla se peso e dettagli del cargo di questo container sono coerenti tra i documenti. Segnala eventuali discrepanze tra B/L, Invoice e Packing List.",
    },
];
